import React from 'react'

interface SvgMarkerIconProps {
  className?: string
  style?: React.CSSProperties
  width?: string
  height?: string
  children?: React.ReactNode
  isStared?: boolean
  cursor?: string
}

export default function SvgMarkerIcon({
  children,
  className,
  style,
  width = '100%',
  height = '100%',
  isStared = false,
  cursor = 'default',
}: SvgMarkerIconProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      width={String(width)}
      height={height}
      fill="none"
      cursor={cursor}
    >
      {children}

      {isStared !== undefined && isStared && (
        <>
          <svg
            x="24"
            y="0"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="7" cy="7" r="6.5" fill="#FFBE0A" stroke="white" />
          </svg>
          <svg
            x="26"
            y="1.5"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_1096_34757)">
              <path
                d="M3.6875 3.75L4.5 1C4.5625 0.8125 4.6875 0.6875 4.8125 0.625C5.125 0.5625 5.4375 0.6875 5.5 1L6.3125 3.75H8.8125C9 3.75 9.125 3.8125 9.25 4C9.4375 4.25 9.375 4.5625 9.125 4.75L7.125 5.9375L7.9375 8.6875C8 8.875 7.9375 9.0625 7.875 9.1875C7.6875 9.4375 7.375 9.5 7.125 9.3125L5 7.625L2.875 9.25C2.6875 9.375 2.5625 9.375 2.375 9.375C2.0625 9.3125 1.9375 9 2 8.6875L2.8125 5.9375L0.875 4.75C0.6875 4.625 0.625 4.5 0.625 4.3125C0.625 4 0.875 3.75 1.1875 3.75H3.6875Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_1096_34757">
                <rect width="10" height="10" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </>
      )}
    </svg>
  )
}
